<template>
  <div
    style="width: fit-content"
    ref="refToggle"
    :tabindex="tabindex"
    class="frm-toggle frm-size-m toggle-button"
    @keydown.left.stop.prevent="toggleRadio('left')"
    @keydown.right.stop.prevent="toggleRadio('right')"
  >
    <label
      v-for="button in list"
      :key="button.text + button.code"
      @click.stop="changeValue(button.code)"
    >
      <input
        type="radio"
        tabindex="-1"
        :name="name"
        :value="button.code"
        :checked="modelValue === button.code"
      />
      <span class="radio-button-span">{{ button.text }}</span>
    </label>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, defineExpose, ref } from "vue";
import { v4 as uuidv4 } from "uuid";
const props = defineProps({
  modelValue: {
    required: true,
  },
  list: {
    type: Array,
    default: () => {
      return [];
    },
    required: true,
  },
  tabindex: {
    type: Number,
    default: 0,
  },
});
const emit = defineEmits(["update:modelValue"]);
const changeValue = (value) => {
  emit("update:modelValue", value);
};
const toggleRadio = (direction) => {
  const listLength = props.list.length;
  const currentIndex = props.list.findIndex((e) => props.modelValue === e.code);
  if (direction === "left") {
    if (currentIndex === 0) {
      changeValue(props.list[listLength - 1].code);
    } else {
      changeValue(props.list[currentIndex - 1].code);
    }
  } else {
    if (currentIndex === listLength - 1) {
      changeValue(props.list[0].code);
    } else {
      changeValue(props.list[currentIndex + 1].code);
    }
  }
};

// **********************************************
// このグループ name
// **********************************************
const name = uuidv4();

// **********************************************
// focus
// **********************************************
const refToggle = ref(null);
const focus = () => {
  refToggle.value.focus();
};
defineExpose({
  focus,
});
</script>
<style scoped>
@media (max-width: 768px) {
  .toggle-button {
    display: contents;
  }
  .radio-button-span {
    border-radius: 6px !important;
    font-size: 1.4rem;
  }
}
</style>